/**
 * Created by ZhangJunPeng on 2017/5/23.
 */

import React from 'react';
import { ContextMenu, MenuItem } from 'react-contextmenu';
import { FormattedMessage } from 'react-intl';
import { ROLES_KEY, SEMICOLON } from '../../utils/constants';
import PropTypes from 'prop-types';

class RightClickMenu extends React.Component {
  /**
   *
   * @param meeting
   * @param adminUserId
   * @returns 1 admin 2 creator 3 holdId 4 member 5 none
   */
  getPermissions = (meeting, adminUserId = "") => {
    const {userInfo = {}, meetingPolicy = {}} = this.props;
    const {userId, roleKey} = userInfo;
    if (roleKey === ROLES_KEY.room_admin && !!meetingPolicy.allowRmAdModify) {
      const adminUsers = adminUserId.split(SEMICOLON);
      if (
        adminUsers.some(uId => uId === userId)
      ) {
        return 1;
      }
    }
    if (userId === meeting.creatorId) {
      return 2;
    }

    if (userId === meeting.holdId) {
      return 3;
    }
    let meetingPeople = [];
    if (meeting.members) {
      meetingPeople = meetingPeople.concat(meeting.members.split(';'));
    }
    if (
      meetingPeople.some(id => {
        return id == userId;
      })
    ) {
      return 4;
    }
    return 5;
  };

  render() {
    const { meeting, createMeetingHandle, roomId, room } = this.props;
    const permissions = this.getPermissions(meeting, room.adminUserId ? room.adminUserId : '');
    const notStart = meeting.status === 0 || meeting.status === 5;
    const audit = meeting.audit === 1;
    const reject = meeting.status === 4;
    //1 admin 2 creator 3 holdId 4 member 5 none
    const edit =
      (!audit && permissions < 4 && notStart) ||
      ((audit && ((meeting.status === 5 || reject) && permissions < 3)) ||
        (meeting.status === 0 && permissions < 2));
    const del =
      (!audit && permissions < 4 && notStart) ||
      ((audit && (meeting.status === 5 && permissions < 3)) ||
        (meeting.status === 0 && permissions < 3));
    return (
      <ContextMenu
        className={
          permissions < 5
            ? 'react-contextmenu-div-style'
            : 'react-contextmenu-no-style'
        }
        id={`right_menu_${meeting.id}_${roomId}`}
      >
        {permissions !== 5 && (
          <MenuItem
            data={{ item: 'item 1' }}
            onClick={e => {
              e.stopPropagation();
              createMeetingHandle({ type: 1, reservation: meeting });
            }}
            onMouseMove={() => {}}
            onMouseLeave={() => {}}
          >
            <FormattedMessage id="search_right_menu_details" />
          </MenuItem>
        )}
        {edit && (
          <MenuItem
            data={{ item: 'item 2' }}
            onClick={e => {
              e.stopPropagation();
              createMeetingHandle({ type: 2, reservation: meeting });
            }}
            onMouseMove={() => {}}
            onMouseLeave={() => {}}
          >
            <FormattedMessage id="search_right_menu_edit" />
          </MenuItem>
        )}
        {del && (
          <MenuItem
            data={{ item: 'item 3' }}
            onClick={e => {
              e.stopPropagation();
              createMeetingHandle({ type: 3, reservation: meeting });
            }}
            onMouseMove={() => {}}
            onMouseLeave={() => {}}
          >
            <FormattedMessage id="search_right_menu_cancel" />
          </MenuItem>
        )}
        {permissions === 5 && (
          <MenuItem
            data={{ item: 'item 4' }}
            onClick={e => {
              e.stopPropagation();
            }}
            onMouseMove={() => {}}
            onMouseLeave={() => {}}
          >
            <FormattedMessage id="meeting_right" />
          </MenuItem>
        )}
      </ContextMenu>
    );
  }
}

RightClickMenu.propTypes = {
  meeting: PropTypes.object.isRequired,
  createMeetingHandle: PropTypes.func.isRequired
};

export default RightClickMenu;



// WEBPACK FOOTER //
// ./src/components/meeting/RightClickMenu.js